<script setup>
import { useApi } from '@/utils/api'
import { useApiRequest } from '@/composables/useApiRequest'

definePage({
  meta: {
    layout: 'default',
    action: 'update',
    subject: 'Supplier',
  },
})

const route = useRoute()
const router = useRouter()
const { loading, errors, request } = useApiRequest()

const form = ref({
  name: '',
  contact_person: '',
  phone: '',
  email: '',
  address: '',
  is_active: true,
})

const fetchLoading = ref(true)
const fetchError = ref('')

// ─── Fetch existing data ──────────────────────────────────────────────────────
onMounted(async () => {
  try {
    // ofetch return body langsung
    const response = await useApi(`/api/v1/suppliers/${route.params.id}`).get()
    const body = response?.data ?? response
    const s = body?.data ?? body

    form.value = {
      name:           s.name           ?? '',
      contact_person: s.contact_person ?? '',
      phone:          s.phone          ?? '',
      email:          s.email          ?? '',
      address:        s.address        ?? '',
      is_active:      s.is_active      ?? true,
    }
  } catch (err) {
    fetchError.value = 'Gagal memuat data supplier.'
    console.error('[SupplierEdit] fetch error', err)
  } finally {
    fetchLoading.value = false
  }
})

// ─── Submit ───────────────────────────────────────────────────────────────────
const submit = async () => {
  const result = await request(() =>
    useApi(`/api/v1/suppliers/${route.params.id}`).put({ body: form.value })
  )

  if (result !== null) {
    router.push({ name: 'purchase-suppliers' })
  }
}
</script>

<template>
  <VRow>
    <VCol cols="12" md="8" lg="6">
      <VCard>
        <VCardTitle class="pt-5 px-5">Edit Supplier</VCardTitle>

        <VDivider />

        <!-- Loading state -->
        <VCardText v-if="fetchLoading" class="pa-10 text-center">
          <VProgressCircular indeterminate color="primary" />
        </VCardText>

        <!-- Fetch error -->
        <VCardText v-else-if="fetchError" class="pa-5">
          <VAlert type="error">{{ fetchError }}</VAlert>
        </VCardText>

        <!-- Form -->
        <VCardText v-else class="pa-5">
          <VAlert
            v-if="errors._general"
            type="error"
            variant="tonal"
            class="mb-4"
          >
            {{ errors._general[0] }}
          </VAlert>

          <VRow>
            <VCol cols="12">
              <VTextField
                v-model="form.name"
                label="Nama Supplier *"
                :error-messages="errors.name"
              />
            </VCol>

            <VCol cols="12" md="6">
              <VTextField
                v-model="form.contact_person"
                label="Contact Person"
                :error-messages="errors.contact_person"
              />
            </VCol>

            <VCol cols="12" md="6">
              <VTextField
                v-model="form.phone"
                label="Telepon"
                :error-messages="errors.phone"
              />
            </VCol>

            <VCol cols="12" md="6">
              <VTextField
                v-model="form.email"
                label="Email"
                type="email"
                :error-messages="errors.email"
              />
            </VCol>

            <VCol cols="12" md="6" class="d-flex align-center">
              <VSwitch
                v-model="form.is_active"
                label="Supplier Aktif"
                color="success"
                hide-details
              />
            </VCol>

            <VCol cols="12">
              <VTextarea
                v-model="form.address"
                label="Alamat"
                rows="3"
                :error-messages="errors.address"
              />
            </VCol>
          </VRow>
        </VCardText>

        <VDivider />

        <VCardActions class="pa-5">
          <VSpacer />
          <VBtn
            variant="tonal"
            :to="{ name: 'purchase-suppliers' }"
          >
            Batal
          </VBtn>
          <VBtn
            color="primary"
            :loading="loading"
            :disabled="fetchLoading || !!fetchError"
            @click="submit"
          >
            Simpan Perubahan
          </VBtn>
        </VCardActions>
      </VCard>
    </VCol>
  </VRow>
</template>
